import { Toaster } from '@gravity-ui/uikit';
import { toastsT } from '../../i18n';

export const toaster = new Toaster();

export const toastError = {
    open(error: string) {
        toaster?.add({
            name: 'toastError',
            theme: 'danger',
            content: error,
            title: toastsT('error'),
            autoHiding: 5000,
            className: 'toast',
        });
    },
};

export const toastSuccess = {
    open(message: string) {
        toaster?.add({
            name: 'toastSuccess',
            theme: 'success',
            content: message,
            title: toastsT('success'),
            autoHiding: 5000,
            className: 'toast',
        });
    },
};

export const toastInfo = {
    open(message: string) {
        toaster?.add({
            name: 'toastInfo',
            theme: 'info',
            content: message,
            title: toastsT('info'),
            autoHiding: 5000,
            className: 'toast',
        });
    },
};
